var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            margin: "12px 0",
            color: "#ee822f",
            "font-size": "14px",
          },
        },
        [
          _vm._v(
            "\n    *班主任老师您好，以下是经过心理测评筛查出来咱们班有异常的同学名单，希望班主任多进行关注引导。如果与我们的评测观察有额外的信息，请班主任记录。\n  "
          ),
        ]
      ),
      _c(
        "TableList",
        {
          attrs: {
            columns: _vm.tabPaneConfig[_vm.tabKey - 1].columns,
            tableData: _vm.tabPaneConfig[_vm.tabKey - 1].tableData,
            loading: _vm.tabPaneConfig[_vm.tabKey - 1].loading,
            scroll: false,
            pagination: _vm.tabPaneConfig[_vm.tabKey - 1].pagination,
          },
          on: { change: _vm.handleTableChange },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ record }) {
                return [
                  _c(
                    "div",
                    { staticClass: "action-detail" },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.viewArchives(record)
                            },
                          },
                        },
                        [_vm._v("我已知晓")]
                      ),
                      _c("a-divider", { attrs: { type: "vertical" } }),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.addCommunicatRecord(record, "view")
                            },
                          },
                        },
                        [_vm._v("评估记录")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticClass: "query-area",
              attrs: { slot: "queryArea" },
              slot: "queryArea",
            },
            [
              _c(
                "div",
                [
                  _c("j-dict-select-tag", {
                    staticStyle: { width: "170px", "margin-right": "15px" },
                    attrs: {
                      placeholder: "请选择年级",
                      dictCode:
                        "school_grade,grade_name,id,0=delete_flag order by sort_order",
                      isShowEmpty: false,
                    },
                    model: {
                      value: _vm.queryParam.gradeId,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "gradeId", $$v)
                      },
                      expression: "queryParam.gradeId",
                    },
                  }),
                  _c("a-input-search", {
                    staticClass: "search-space",
                    staticStyle: { width: "170px" },
                    attrs: { placeholder: "请输入学生名字" },
                    on: { change: _vm.searchName },
                    model: {
                      value: _vm.queryParam.studentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParam, "studentName", $$v)
                      },
                      expression: "queryParam.studentName",
                    },
                  }),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.queryTable },
                    },
                    [_vm._v("查询")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "a-button",
                    {
                      staticStyle: { "margin-right": "15px" },
                      attrs: { type: "primary", icon: "download" },
                      on: {
                        click: function ($event) {
                          return _vm.handleExportXls("危机干预学生清单")
                        },
                      },
                    },
                    [_vm._v("\n          导出\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c("InformationNote", { ref: "informationNoteRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }